import type { FaireProductEntity } from "../../entity_types/product";

export const p_8o72nhx7qb: FaireProductEntity = {
  token: "p_8o72nhx7qb",
  type: "product",
  name: "Top Grain Cowhide Bi-fold Wallet with Side Flap",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4b1f96364339d031bc133535f1b0ddd2a9a4345576b5498263bec9a452a50a13.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/522d89c743a072c5cbed4d0d389ad099dc9b170bbe5e225c7914465a17e93aad.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
